/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateFeatureBundleRequest,
  RevertToRevisionRequest,
  UpdateFeatureBundleRequest,
} from '../models/index';
import {
    CreateFeatureBundleRequestFromJSON,
    CreateFeatureBundleRequestToJSON,
    RevertToRevisionRequestFromJSON,
    RevertToRevisionRequestToJSON,
    UpdateFeatureBundleRequestFromJSON,
    UpdateFeatureBundleRequestToJSON,
} from '../models/index';

export interface CreateBundleRequest {
    createFeatureBundleRequest: CreateFeatureBundleRequest;
}

export interface DeleteBundleRequest {
    id: string;
}

export interface GetBundleRequest {
    id: string;
}

export interface ListRevisionsRequest {
    id: string;
}

export interface RevertToRevisionOperationRequest {
    id: string;
    revertToRevisionRequest: RevertToRevisionRequest;
}

export interface SyncBundleToTenantsRequest {
    id: string;
    requestBody?: { [key: string]: string; };
}

export interface UpdateBundleRequest {
    id: string;
    updateFeatureBundleRequest: UpdateFeatureBundleRequest;
}

/**
 * FeatureBundleAdminApi - interface
 * 
 * @export
 * @interface FeatureBundleAdminApiInterface
 */
export interface FeatureBundleAdminApiInterface {
    /**
     * 
     * @summary Create feature bundle
     * @param {CreateFeatureBundleRequest} createFeatureBundleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureBundleAdminApiInterface
     */
    createBundleRaw(requestParameters: CreateBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Create feature bundle
     */
    createBundle(requestParameters: CreateBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Delete feature bundle
     * @param {string} id Entity ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureBundleAdminApiInterface
     */
    deleteBundleRaw(requestParameters: DeleteBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Delete feature bundle
     */
    deleteBundle(requestParameters: DeleteBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get feature bundle by entity ID or bundle_id
     * @param {string} id Entity ID or bundle_id (e.g. MXDR, ALL_FEATURES)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureBundleAdminApiInterface
     */
    getBundleRaw(requestParameters: GetBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get feature bundle by entity ID or bundle_id
     */
    getBundle(requestParameters: GetBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns all bundles (active and inactive) for admin UI
     * @summary List all feature bundles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureBundleAdminApiInterface
     */
    listBundlesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns all bundles (active and inactive) for admin UI
     * List all feature bundles
     */
    listBundles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns version history for the bundle (id can be entity ID or bundle_id). Newest first.
     * @summary List bundle revision history
     * @param {string} id Entity ID or bundle_id (e.g. MXDR)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureBundleAdminApiInterface
     */
    listRevisionsRaw(requestParameters: ListRevisionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns version history for the bundle (id can be entity ID or bundle_id). Newest first.
     * List bundle revision history
     */
    listRevisions(requestParameters: ListRevisionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Restores the bundle definition (name, description, featureIds) from the given revision. Optionally runs sync so existing tenant grants are updated per bundle_sync_policy.
     * @summary Revert bundle to a previous revision
     * @param {string} id Entity ID or bundle_id (e.g. MXDR)
     * @param {RevertToRevisionRequest} revertToRevisionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureBundleAdminApiInterface
     */
    revertToRevisionRaw(requestParameters: RevertToRevisionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Restores the bundle definition (name, description, featureIds) from the given revision. Optionally runs sync so existing tenant grants are updated per bundle_sync_policy.
     * Revert bundle to a previous revision
     */
    revertToRevision(requestParameters: RevertToRevisionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * For each active grant of this bundle, add/remove entitlements to match current bundle definition per bundle_sync_policy (SYNC_TO_BUNDLE or GRANDFATHER). No-op if policy is NO_CHANGE.
     * @summary Sync bundle to tenants
     * @param {string} id Entity ID or bundle_id (e.g. MXDR)
     * @param {{ [key: string]: string; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureBundleAdminApiInterface
     */
    syncBundleToTenantsRaw(requestParameters: SyncBundleToTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * For each active grant of this bundle, add/remove entitlements to match current bundle definition per bundle_sync_policy (SYNC_TO_BUNDLE or GRANDFATHER). No-op if policy is NO_CHANGE.
     * Sync bundle to tenants
     */
    syncBundleToTenants(requestParameters: SyncBundleToTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Updates the bundle definition. Sync runs immediately after save per bundle_sync_policy (NO_CHANGE = no-op, SYNC_TO_BUNDLE/GRANDFATHER = update existing tenant grants).
     * @summary Update feature bundle
     * @param {string} id Entity ID
     * @param {UpdateFeatureBundleRequest} updateFeatureBundleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureBundleAdminApiInterface
     */
    updateBundleRaw(requestParameters: UpdateBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Updates the bundle definition. Sync runs immediately after save per bundle_sync_policy (NO_CHANGE = no-op, SYNC_TO_BUNDLE/GRANDFATHER = update existing tenant grants).
     * Update feature bundle
     */
    updateBundle(requestParameters: UpdateBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class FeatureBundleAdminApi extends runtime.BaseAPI implements FeatureBundleAdminApiInterface {

    /**
     * Create feature bundle
     */
    async createBundleRaw(requestParameters: CreateBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['createFeatureBundleRequest'] == null) {
            throw new runtime.RequiredError(
                'createFeatureBundleRequest',
                'Required parameter "createFeatureBundleRequest" was null or undefined when calling createBundle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/feature-bundles`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFeatureBundleRequestToJSON(requestParameters['createFeatureBundleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create feature bundle
     */
    async createBundle(requestParameters: CreateBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createBundleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete feature bundle
     */
    async deleteBundleRaw(requestParameters: DeleteBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteBundle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/feature-bundles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete feature bundle
     */
    async deleteBundle(requestParameters: DeleteBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deleteBundleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get feature bundle by entity ID or bundle_id
     */
    async getBundleRaw(requestParameters: GetBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getBundle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/feature-bundles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get feature bundle by entity ID or bundle_id
     */
    async getBundle(requestParameters: GetBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBundleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all bundles (active and inactive) for admin UI
     * List all feature bundles
     */
    async listBundlesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/feature-bundles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns all bundles (active and inactive) for admin UI
     * List all feature bundles
     */
    async listBundles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listBundlesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns version history for the bundle (id can be entity ID or bundle_id). Newest first.
     * List bundle revision history
     */
    async listRevisionsRaw(requestParameters: ListRevisionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling listRevisions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/feature-bundles/{id}/revisions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns version history for the bundle (id can be entity ID or bundle_id). Newest first.
     * List bundle revision history
     */
    async listRevisions(requestParameters: ListRevisionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listRevisionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Restores the bundle definition (name, description, featureIds) from the given revision. Optionally runs sync so existing tenant grants are updated per bundle_sync_policy.
     * Revert bundle to a previous revision
     */
    async revertToRevisionRaw(requestParameters: RevertToRevisionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling revertToRevision().'
            );
        }

        if (requestParameters['revertToRevisionRequest'] == null) {
            throw new runtime.RequiredError(
                'revertToRevisionRequest',
                'Required parameter "revertToRevisionRequest" was null or undefined when calling revertToRevision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/feature-bundles/{id}/revert-to-revision`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevertToRevisionRequestToJSON(requestParameters['revertToRevisionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Restores the bundle definition (name, description, featureIds) from the given revision. Optionally runs sync so existing tenant grants are updated per bundle_sync_policy.
     * Revert bundle to a previous revision
     */
    async revertToRevision(requestParameters: RevertToRevisionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.revertToRevisionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * For each active grant of this bundle, add/remove entitlements to match current bundle definition per bundle_sync_policy (SYNC_TO_BUNDLE or GRANDFATHER). No-op if policy is NO_CHANGE.
     * Sync bundle to tenants
     */
    async syncBundleToTenantsRaw(requestParameters: SyncBundleToTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling syncBundleToTenants().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/feature-bundles/{id}/sync`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * For each active grant of this bundle, add/remove entitlements to match current bundle definition per bundle_sync_policy (SYNC_TO_BUNDLE or GRANDFATHER). No-op if policy is NO_CHANGE.
     * Sync bundle to tenants
     */
    async syncBundleToTenants(requestParameters: SyncBundleToTenantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.syncBundleToTenantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the bundle definition. Sync runs immediately after save per bundle_sync_policy (NO_CHANGE = no-op, SYNC_TO_BUNDLE/GRANDFATHER = update existing tenant grants).
     * Update feature bundle
     */
    async updateBundleRaw(requestParameters: UpdateBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBundle().'
            );
        }

        if (requestParameters['updateFeatureBundleRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFeatureBundleRequest',
                'Required parameter "updateFeatureBundleRequest" was null or undefined when calling updateBundle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/admin/feature-bundles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFeatureBundleRequestToJSON(requestParameters['updateFeatureBundleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Updates the bundle definition. Sync runs immediately after save per bundle_sync_policy (NO_CHANGE = no-op, SYNC_TO_BUNDLE/GRANDFATHER = update existing tenant grants).
     * Update feature bundle
     */
    async updateBundle(requestParameters: UpdateBundleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateBundleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
